export const isAuthReduser = (state = false, action) => {
    switch (action.type) {
        case 'CHECK_AUTH':
          return !state
        default:
          return state
    }
}
